<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>堆雪球管理</el-breadcrumb-item>
      <el-breadcrumb-item>API测试</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card" style="margin-bottom: 20px;">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">API测试</span>
      </div>

      <el-tabs v-model="activeTab" type="card">
        <!-- 获取微信账号列表 -->
        <el-tab-pane label="微信账号" name="weixinList">
          <el-form :model="weixinForm" :inline="true" label-width="100px" size="small" style="margin-bottom: 20px;">
            <el-form-item label="每页数量：">
              <el-input-number v-model="weixinForm.pageSize" :min="1" :max="200" style="width: 120px;"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getWeixinList" :loading="weixinLoading">获取列表</el-button>
              <el-button type="success" @click="saveWeixinList" :loading="updateWeixinLoading" style="margin-left: 10px;">保存列表</el-button>
            </el-form-item>
          </el-form>
          <div v-if="weixinList.length > 0">
            <el-table :data="weixinList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="id" label="头像" width="100">
                <template slot-scope="scope">
                  <el-image :src="scope.row.avatar" fit="fill" :preview-src-list="[scope.row.avatar]" style="width: 50px; height: 50px;"></el-image>
                </template>
              </el-table-column>
              <el-table-column prop="nickname" label="微信昵称" width="200"></el-table-column>
              <el-table-column prop="alias" label="微信号" width="200"></el-table-column>
              <el-table-column prop="totalFriend" label="好友数量" width="100"></el-table-column>
              <el-table-column prop="id" label="账号id"></el-table-column>
            </el-table>
            <div style="margin-top: 20px; text-align: center;">
              <el-pagination
                @size-change="handleWeixinSizeChange"
                @current-change="handleWeixinCurrentChange"
                :current-page="weixinForm.pageIndex + 1"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="weixinForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="weixinTotal">
              </el-pagination>
            </div>
          </div>
          <div v-else class="no-data">
            <el-empty description="暂无数据，请点击获取列表"></el-empty>
          </div>
        </el-tab-pane>

        <!-- 获取好友列表 -->
        <el-tab-pane label="好友列表" name="friendList">
          <el-form :model="friendForm" :rules="friendRules" ref="friendForm" :inline="true" label-width="100px" size="small" style="margin-bottom: 20px;">
            <el-form-item label="时间范围：" prop="timeRange">
              <el-date-picker
                v-model="friendForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 400px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="微信账号：" prop="wechatAccountId">
              <el-select v-model="friendForm.wechatAccountId" placeholder="请选择微信账号" clearable style="width: 200px;">
                <el-option
                  v-for="item in weixinList"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <br>
            <el-form-item label="好友关键字：" prop="keyword">
              <el-input v-model="friendForm.keyword" placeholder="请输入好友关键字" clearable style="width: 200px;"></el-input>
            </el-form-item>

            <el-form-item label="每页数量：" prop="pageSize">
              <el-input-number v-model="friendForm.pageSize" :min="1" style="width: 120px;"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getFriendList" :loading="friendLoading">获取列表</el-button>
              <el-button type="success" @click="saveFriendList" :loading="updateFriendLoading" style="margin-left: 10px;">保存列表</el-button>

            </el-form-item>
          </el-form>

          <div v-if="friendList.length > 0">
            <el-table :data="friendList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="avatar" label="好友头像" width="100">
                <template slot-scope="scope">
                  <el-image :src="scope.row.avatar" fit="fill" :preview-src-list="[scope.row.avatar]" style="width: 50px; height: 50px;"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="好友信息" width="200">
                <template slot-scope="scope">
                  <div style="font-size: 12px;">
                    <div>昵称：{{ scope.row.nickname }}</div>
                    <div>微信号：{{ scope.row.alias }}</div>
                    <div>微信Id：{{ scope.row.wechatId }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="性别" width="50">
                <template slot-scope="scope">
                  {{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' : '未知' }}
                </template>
              </el-table-column>
              <el-table-column prop="id" label="好友Id"></el-table-column>
              <el-table-column label="时间信息" width="200">
                <template slot-scope="scope">
                  <div>
                    <div v-if="scope.row.passTime">
                      <span style="color: #409EFF;">通过: </span>
                      {{ formatTimestamp(scope.row.passTime) }}
                    </div>
                    <div v-if="scope.row.lastActivityTime" style="margin-top: 5px;">
                      <span style="color: #67C23A;">活跃: </span>
                      {{ formatTimestamp(scope.row.lastActivityTime) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="conRemark" label="备注"></el-table-column>
            </el-table>
            <div style="margin-top: 20px; text-align: center;">
              <el-pagination
                @size-change="handleFriendSizeChange"
                @current-change="handleFriendCurrentChange"
                :current-page="friendForm.pageIndex + 1"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="friendForm.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="friendTotal">
              </el-pagination>
            </div>
          </div>
          <div v-else class="no-data">
            <el-empty description="暂无数据，请设置查询条件后获取列表"></el-empty>
          </div>
        </el-tab-pane>

        <!-- 获取聊天搜索列表 -->
        <el-tab-pane label="聊天搜索" name="chatSearch">
          <el-form :model="chatSearchForm" :rules="chatSearchRules" ref="chatSearchForm" :inline="true" size="small" style="margin-bottom: 20px;">
            <el-form-item label="日期范围：" prop="dateRange">
              <el-date-picker
                v-model="chatSearchForm.dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                style="width: 240px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="微信账号：" prop="wechatAccountId">
              <el-select v-model="chatSearchForm.wechatAccountId" placeholder="请选择微信账号" clearable style="width: 150px;">
                <el-option
                  v-for="item in weixinList"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="好友关键词：" prop="friendKeyword">
              <el-input v-model="chatSearchForm.friendKeyword" placeholder="请输入好友关键词" clearable style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="每页数量：" prop="pageSize">
              <el-input-number v-model="chatSearchForm.pageSize" :min="1" :max="200" style="width: 120px;"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getChatSearch" :loading="chatSearchLoading">搜索记录</el-button>
            </el-form-item>
          </el-form>

          <div v-if="chatSearchList.length > 0">
            <el-table :data="chatSearchList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="avatar" label="好友头像" width="100">
                <template slot-scope="scope">
                  <el-image :src="scope.row.avatar" fit="fill" :preview-src-list="[scope.row.avatar]" style="width: 50px; height: 50px;"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="好友信息" width="200">
                <template slot-scope="scope">
                  <div style="font-size: 12px;">
                    <div>昵称：{{ scope.row.nickname }}</div>
                    <div>微信号：{{ scope.row.alias }}</div>
                    <div>微信Id：{{ scope.row.wechatId }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="gender" label="性别" width="80">
                <template slot-scope="scope">
                  {{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' : '未知' }}
                </template>
              </el-table-column>
              <el-table-column prop="ownerAvatar" label="对话人头像" width="100">
                <template slot-scope="scope">
                  <el-image :src="scope.row.ownerAvatar" fit="fill" :preview-src-list="[scope.row.ownerAvatar]" style="width: 50px; height: 50px;"></el-image>
                </template>
              </el-table-column>
              <el-table-column label="对话人信息" width="260">
                <template slot-scope="scope">
                  <div style="font-size: 12px;">
                    <div>昵称：{{ scope.row.ownerNickname }}</div>
                    <div>微信号：{{ scope.row.ownerAlias }}</div>
                    <div>微信Id：{{ scope.row.ownerWechatId }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="msgCount" label="对话条数" width="80">
                <template slot-scope="scope">
                  {{ scope.row.msgCount }}
                </template>
              </el-table-column>
              <el-table-column label="双方ID">
                <template slot-scope="scope">
                  <div style="font-size: 12px;">
                    <div>对话人ID：{{ scope.row.wechatAccountId }}</div>
                    <div>好友ID：{{ scope.row.wechatFriendId }}</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 10px;">
              <el-tag type="info">总计: {{ chatSearchTotal }} 条记录</el-tag>
            </div>
          </div>
          <div v-else class="no-data">
            <el-empty description="暂无数据，请设置查询条件后搜索记录"></el-empty>
          </div>
        </el-tab-pane>

        <!-- 获取聊天记录 -->
        <el-tab-pane label="聊天记录" name="chatRecords">
          <el-form :model="chatRecordForm" :rules="chatRecordRules" ref="chatRecordForm" :inline="true" size="small" style="margin-bottom: 20px;">
            <el-form-item label="时间范围：" prop="timeRange">
              <el-date-picker
                v-model="chatRecordForm.timeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                style="width: 320px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="好友ID：" prop="wechatFriendId">
              <el-input v-model="chatRecordForm.wechatFriendId" placeholder="请输入微信好友ID" clearable style="width: 150px;"></el-input>
            </el-form-item>
            <el-form-item label="微信账号：" prop="wechatAccountId">
              <el-select v-model="chatRecordForm.wechatAccountId" placeholder="请选择微信账号" clearable style="width: 150px;">
                <el-option
                  v-for="item in weixinList"
                  :key="item.id"
                  :label="item.nickname"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="每页数量：" prop="pageSize">
              <el-input-number v-model="chatRecordForm.pageSize" :min="1" :max="200" style="width: 120px;"></el-input-number>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getChatRecord" :loading="chatRecordLoading">获取记录</el-button>
            </el-form-item>
          </el-form>

          <div v-if="chatRecordList.length > 0">
            <el-table :data="chatRecordList" border style="width: 100%">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="content" label="消息内容"></el-table-column>
              <el-table-column label="消息类型" width="150">
                <template slot-scope="scope">
                  <div>类型：{{scope.row.msgType}}</div>
                  <div>子类型：{{scope.row.msgSubType}}</div>
                </template>
              </el-table-column>
              <el-table-column label="发送时间" width="200">
                <template slot-scope="scope">
                  {{ new Date(scope.row.wechatTime).toLocaleString() }}
                </template>
              </el-table-column>
              <el-table-column label="发送者" width="150">
                <template slot-scope="scope">
                  {{scope.row.isSend?'我':'好友'}}
                </template>
              </el-table-column>
            </el-table>
            <div style="margin-top: 10px;">
              <el-button type="primary" @click="loadMoreChatRecord">继续加载</el-button>
            </div>
          </div>
          <div v-else class="no-data">
            <el-empty description="暂无数据，请设置查询条件后获取记录"></el-empty>
          </div>
        </el-tab-pane>

      </el-tabs>

    </el-card>

  </div>
</template>

<script>
export default {
  name: 'DuixueqiuApiTest',
  data () {
    return {
      activeTab: 'weixinList',

      // 微信账号列表
      weixinList: [],
      weixinTotal: 0,
      weixinLoading: false,
      updateWeixinLoading: false,
      weixinForm: {
        pageIndex: 0,
        pageSize: 20
      },

      // 好友列表
      friendList: [],
      friendTotal: 0,
      friendLoading: false,
      updateFriendLoading: false,
      friendForm: {
        timeRange: null,
        wechatAccountId: '',
        keyword: null,
        pageIndex: 0,
        pageSize: 20
      },
      friendRules: {
        timeRange: [
          {
            validator: (rule, value, callback) => {
              if (value && value.length === 2) {
                // 如果选择了时间范围，必须两个时间都有值
                if (!value[0] || !value[1]) {
                  callback(new Error('请选择完整的时间范围'))
                } else {
                  callback()
                }
              } else if (value && value.length === 1) {
                // 如果只选择了一个时间，提示需要选择完整范围
                callback(new Error('请选择完整的时间范围'))
              } else {
                // 允许不选择时间范围
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },

      // 搜索聊天记录
      chatSearchList: [],
      chatSearchTotal: 0,
      chatSearchLoading: false,
      chatSearchForm: {
        dateRange: null,
        wechatAccountId: '',
        friendKeyword: '',
        pageSize: 20
      },
      chatSearchRules: {
        dateRange: [
          { required: true, message: '请选择日期范围', trigger: 'change' }
        ]
      },

      // 获取聊天记录
      chatRecordList: [],
      chatRecordTotal: 0,
      chatRecordLoading: false,
      chatRecordForm: {
        timeRange: null,
        wechatFriendId: '',
        wechatAccountId: '',
        pageSize: 20
      },
      chatRecordRules: {
        timeRange: [
          { required: true, message: '请选择时间范围', trigger: 'change' }
        ],
        wechatFriendId: [
          { required: true, message: '请输入微信好友ID', trigger: 'blur' }
        ],
        wechatAccountId: [
          { required: true, message: '请选择微信账号', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    // 页面加载时获取微信账号列表
    this.getWeixinList()
  },
  methods: {
    // 获取微信账号列表
    async getWeixinList () {
      this.weixinLoading = true
      try {
        const { data: res } = await this.$http.get('duixueqiu/getWeixinList', {
          params: {
            pageIndex: this.weixinForm.pageIndex,
            pageSize: this.weixinForm.pageSize
          }
        })
        if (res.meta.status === 200) {
          this.weixinList = res.data.results || []
          this.weixinTotal = res.data.total || 0
          this.$message.success('获取微信账号列表成功')
        } else {
          this.$message.error(res.meta.msg || '获取微信账号列表失败')
        }
      } catch (error) {
        this.$message.error('获取微信账号列表失败：' + error.message)
      } finally {
        this.weixinLoading = false
      }
    },

    // 保存微信账号列表
    async saveWeixinList () {
      if (!this.weixinList || this.weixinList.length === 0) {
        this.$message.warning('没有可保存的微信账号数据，请先获取列表')
        return
      }

      this.updateWeixinLoading = true
      try {
        const { data: res } = await this.$http.post('duixueqiu/saveWeixinList', {
          weixinList: this.weixinList
        })
        if (res.meta.status === 200) {
          this.$message.success(`成功保存${this.weixinList.length}条微信账号记录`)
        } else {
          this.$message.error(res.meta.msg || '保存微信账号列表失败')
        }
      } catch (error) {
        this.$message.error('保存微信账号列表失败：' + error.message)
      } finally {
        this.updateWeixinLoading = false
      }
    },

    // 保存好友列表
    async saveFriendList () {
      if (!this.friendList || this.friendList.length === 0) {
        this.$message.warning('没有可保存的好友数据，请先获取列表')
        return
      }

      this.updateFriendLoading = true
      try {
        const { data: res } = await this.$http.post('duixueqiu/saveFriendList', {
          friendList: this.friendList
        })
        if (res.meta.status === 200) {
          this.$message.success(`成功保存${this.friendList.length}条好友记录`)
        } else {
          this.$message.error(res.meta.msg || '保存好友列表失败')
        }
      } catch (error) {
        this.$message.error('保存好友列表失败：' + error.message)
      } finally {
        this.updateFriendLoading = false
      }
    },

    // 获取好友列表
    async getFriendList () {
      this.$refs.friendForm.validate(async (valid) => {
        if (!valid) return

        this.friendLoading = true
        try {
          const { data: res } = await this.$http.post('duixueqiu/getFriendList', {
            passTimeFrom: this.friendForm.timeRange && this.friendForm.timeRange[0] ? this.friendForm.timeRange[0] : null,
            passTimeTo: this.friendForm.timeRange && this.friendForm.timeRange[1] ? this.friendForm.timeRange[1] : null,
            wechatAccountId: this.friendForm.wechatAccountId,
            keyword: this.friendForm.keyword,
            pageIndex: this.friendForm.pageIndex,
            pageSize: this.friendForm.pageSize
          })

          if (res.meta.status === 200) {
            this.friendList = res.data.results || []
            this.friendTotal = res.data.total || 0
            this.$message.success('获取好友列表成功')
          } else {
            this.$message.error(res.meta.msg || '获取好友列表失败')
          }
        } catch (error) {
          this.$message.error('获取好友列表失败：' + error.message)
        } finally {
          this.friendLoading = false
        }
      })
    },

    // 搜索聊天记录
    async getChatSearch () {
      this.$refs.chatSearchForm.validate(async (valid) => {
        if (!valid) return

        this.chatSearchLoading = true
        try {
          const { data: res } = await this.$http.post('duixueqiu/getChatSearch', {
            from: this.chatSearchForm.dateRange && this.chatSearchForm.dateRange.length > 0 ? this.chatSearchForm.dateRange[0] : '',
            to: this.chatSearchForm.dateRange && this.chatSearchForm.dateRange.length > 1 ? this.chatSearchForm.dateRange[1] : '',
            wechatAccountId: this.chatSearchForm.wechatAccountId,
            friendKeyword: this.chatSearchForm.friendKeyword,
            pageSize: this.chatSearchForm.pageSize
          })

          if (res.meta.status === 200) {
            this.chatSearchList = res.data.results || []
            this.chatSearchTotal = res.data.total || 0
            this.$message.success('搜索聊天记录成功')
          } else {
            this.$message.error(res.meta.msg || '搜索聊天记录失败')
          }
        } catch (error) {
          this.$message.error('搜索聊天记录失败：' + error.message)
        } finally {
          this.chatSearchLoading = false
        }
      })
    },

    // 获取聊天记录
    async getChatRecord () {
      this.$refs.chatRecordForm.validate(async (valid) => {
        if (!valid) return

        this.chatRecordLoading = true
        try {
          const params = new URLSearchParams({
            smallWechatTime: this.chatRecordForm.timeRange ? this.chatRecordForm.timeRange[0] : '',
            bigWechatTime: this.chatRecordForm.timeRange ? this.chatRecordForm.timeRange[1] : '',
            wechatFriendId: this.chatRecordForm.wechatFriendId,
            wechatAccountId: this.chatRecordForm.wechatAccountId,
            pageSize: this.chatRecordForm.pageSize
          })

          const { data: res } = await this.$http.get(`duixueqiu/getChatRecord?${params}`)

          if (res.meta.status === 200) {
            this.chatRecordList = res.data || []
            this.chatRecordTotal = res.data.length || 0
            this.$message.success('获取聊天记录成功')
          } else {
            this.$message.error(res.meta.msg || '获取聊天记录失败')
          }
        } catch (error) {
          this.$message.error('获取聊天记录失败：' + error.message)
        } finally {
          this.chatRecordLoading = false
        }
      })
    },

    // 加载更多聊天记录
    async loadMoreChatRecord () {
      if (this.chatRecordList.length === 0) return this.$message.info('没有更多聊天记录了')
      this.chatRecordLoading = true
      try {
        const params = new URLSearchParams({
          smallWechatTime: this.chatRecordList[this.chatRecordList.length - 1].wechatTime,
          bigWechatTime: this.chatRecordForm.timeRange ? this.chatRecordForm.timeRange[1] : '',
          wechatFriendId: this.chatRecordForm.wechatFriendId,
          wechatAccountId: this.chatRecordForm.wechatAccountId,
          pageSize: this.chatRecordForm.pageSize
        })

        const { data: res } = await this.$http.get(`duixueqiu/getChatRecord?${params}`)
        // 保存当前窗口滚动位置
        const scrollTop = window.scrollY
        if (res.meta.status === 200) {
          this.chatRecordList = [...this.chatRecordList, ...res.data || []]
          this.chatRecordTotal = this.chatRecordList.length || 0
          this.$message.success('获取聊天记录成功')
          // 恢复滚动位置
          this.$nextTick(() => {
            window.scrollTo(0, scrollTop)
          })
        } else {
          this.$message.error(res.meta.msg || '获取聊天记录失败')
        }
      } catch (error) {
        this.$message.error('获取聊天记录失败：' + error.message)
      } finally {
        this.chatRecordLoading = false
      }
    },

    // 格式化时间戳为年月日时分秒
    formatTimestamp (timestamp) {
      if (!timestamp) return '-'

      // 如果是10位时间戳，转换为13位
      const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
      const date = new Date(ts)

      // 检查日期是否有效
      if (isNaN(date.getTime())) return '-'

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },

    // 微信账号列表分页事件处理
    handleWeixinSizeChange (val) {
      this.weixinForm.pageSize = val
      this.weixinForm.pageIndex = 0
      this.getWeixinList()
    },

    handleWeixinCurrentChange (val) {
      this.weixinForm.pageIndex = val - 1
      this.getWeixinList()
    },

    // 好友列表分页处理
    handleFriendSizeChange (val) {
      this.friendForm.pageSize = val
      this.friendForm.pageIndex = 0
      this.getFriendList()
    },

    handleFriendCurrentChange (val) {
      this.friendForm.pageIndex = val - 1
      this.getFriendList()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.flexContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cardHeader {
  font-size: 24px;
  font-weight: bold;
}

.no-data {
  text-align: center;
  padding: 20px;
}
</style>
